import { css } from '@creditas/stylitas'

const paginationDisabled = ({ theme }) => css`
  background: transparent;
  pointer-events: none;
  svg {
    color: ${theme.bColorNeutral20};
    fill: currentColor;
  }
`

const bgTransparent = css`
  background: transparent;
`

const hideDropDown = css`
  & > div:nth-of-type(3) {
    display: none;
  }
`

const alignArrowsRight = css`
  & > div:nth-of-type(2) {
    & > div {
      justify-content: flex-end;
    }
  }
`

const pagination = ({ isOnFirstPage, isOnLastPage, theme }) => css`
  button {
    min-width: 40px;
    max-height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    outline: none;
    &[aria-label~='page'] {
      &[data-active='true'] {
        border-bottom: none;
        font-weight: normal;
        border-radius: 12px;
        background: ${theme.bColorNeutral15};
      }
      &:hover {
        border-radius: 12px;
        background: ${theme.bColorNeutral10};
      }
      &:focus:not([data-active='true']) {
        background: transparent;
      }
      &[aria-label~='first'] {
        ${isOnFirstPage && paginationDisabled({ theme })}
      }
      &[aria-label~='previous'] {
        ${isOnFirstPage && paginationDisabled({ theme })}
      }
      &[aria-label~='next'] {
        ${isOnLastPage && paginationDisabled({ theme })}
      }
      &[aria-label~='last'] {
        ${isOnLastPage && paginationDisabled({ theme })}
      }
    }
  }
`

export { pagination, bgTransparent, hideDropDown, alignArrowsRight }
